import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function LegalShell({ kind, title, updated, children }) {
  return (
    <main className="bg-zoku-bg text-zoku-ink min-h-screen" data-testid={`${kind}-page`}>
      <Navbar />
      <section className="pt-32 pb-24 md:pt-40 md:pb-32 max-w-3xl mx-auto px-6 md:px-8">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm text-zoku-ink2 hover:text-zoku-orange transition-colors"
          data-testid="back-home-link"
        >
          <ArrowLeft className="w-4 h-4" />
          Back
        </Link>
        <p className="mt-10 text-xs font-bold tracking-[0.2em] uppercase text-zoku-orange">Legal</p>
        <h1 className="mt-3 font-heading text-4xl md:text-6xl font-bold leading-[1.03] tracking-tight">
          {title}
        </h1>
        <p className="mt-4 text-sm text-zoku-ink3">{updated}</p>

        <article className="legal-prose mt-12 text-zoku-ink2 leading-relaxed">{children}</article>
      </section>
      <Footer />
    </main>
  );
}
